<template>
  <div v-if="loaded" class="mb-8 flex flex-col md:gap-[35px] gap-5">
    <div
      v-for="(section, index) in recommendations"
      :key="section._id"
      class="recommendation-page"
      :class="
        section.style_type === 2 && section?.features?.length > 0
          ? 'special-section'
          : ''
      "
    >
      <!-- TODO: cambiar a typo banner -->
      <div
        v-if="
          section.slug === 'aun-no-tienes-la-app-de-wegow' ||
            section.slug === 'aun-no-tienes-la-app-de-wegow-2'
        "
      >
        <banner-download-app />
      </div>
      <div v-else-if="section.slug === 'friends-banner'">
        <!-- TODO: no deberia salir -->
        <conect-fb-friends />
      </div>
      <div v-else-if="section.slug === 'conecta-con-tus-amigos'">
        <connect-friends />
      </div>
      <div v-else-if="section.slug === 'vive-la-musica-de-una-forma-diferente'">
        <sign-up-banner />
      </div>
      <div v-else-if="section.slug === 'weswap'">
        <weswap-banner />
      </div>
      <!-- <venue-banner
        v-else-if="section.slug === 'venue-banner' && section.enabled"
      /> -->
      <!-- TODO: añadir version artista y salas -->
      <provenues-banner
        v-else-if="section.slug === 'provenues'"
        :has-padding="!mixed"
      />
      <div
        v-else-if="section?.features?.length > 0"
        class="slide-section flex flex-col md:px-8 lg:px-16 l:px-0"
      >
        <h2
          v-if="
            previousChapterTitle(index) != section.chapter &&
              section.chapter_title
          "
          class="mt-2 mb-6 pl-2 md:pl-0"
        >
          <!-- {{ section.chapter_title }} -->
          <router-link
            v-if="isRecommendedSection(section)"
            :to="sectionLink(section)"
          >
            {{ section.chapter_title }}
          </router-link>
          <template v-else>{{ section.chapter_title }}</template>

        </h2>
        <h2 v-if="section.title" class="md:mb-4 mb-2 pl-2 md:pl-0 text-[15px]">
          <!-- {{ section.title }} -->
          <router-link
            v-if="isRecommendedSection(section)"
            :to="sectionLink(section)"
          >
            {{ section.title }}
          </router-link>
          <template v-else>{{ section.title }}</template>
        </h2>
        <div class="relative">
          <div
            v-if="section.style_type !== 2"
            class="slider-gradient bottom-0"
          ></div>
          <carousel
            class="carousel fixed-carousel-arrows"
            :class="getClass(section)"
            :wrap-around="false"
            :settings="settings"
            :breakpoints="breakpoints(section)"
            :transition="500"
            :aria-label="recommendations.slug"
            @mousedown="handleMouseDown"
            @mousemove="cancelOpen"
            @mouseup="handleMouseUp"
          >
            <slide
              v-for="(row, elementindex) in section.features"
              :key="row.id"
              :class="elementindex === 0 ? 'pl-[9px] md:pl-0' : ''"
              :aria-hidden="false"
            >
              <event-card
                v-if="row && section.type === 'event'"
                :event="row"
                :type="getEventType(section)"
                :is-link="showLink"
                :img-height="section.style_type === 5 ? '70%' : '60%'"
                open-external
                @empty-ad="deleteAd($event)"
              />

              <artist-card
                v-if="row && section.type === 'artist'"
                :artist="row"
                :type="getDefaultType(section)"
                :is-link="showLink"
              />

              <venue-card
                v-if="row && section.type === 'venue'"
                :venue="row"
                :type="getDefaultType(section)"
                :is-link="showLink"
              />
            </slide>
            <template #addons>
              <navigation class="hidden md:block" />
            </template>
          </carousel>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="my-24">
    <wegow-loader class="min-h-screen" />
  </div>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import { useRecommendation } from "@/composables/useRecommendation";

import WegowLoader from "@/components/general/ui/WegowLoader";
import BannerDownloadApp from "@/components/wegow/banners/BannerDownloadApp.vue";
import ConectFbFriends from "@/components/wegow/banners/ConectFbFriends";
import ConnectFriends from "@/components/wegow/banners/ConnectFriends";
import VenueBanner from "@/components/wegow/banners/VenueBanner.vue";
import SignUpBanner from "@/components/wegow/banners/SignUpBanner";
import WeswapBanner from "@/components/wegow/banners/WeswapBanner.vue";
import ProvenuesBanner from "@/components/wegow/banners/ProvenuesBanner.vue";
import EventCard from "@/components/wegow/ui/cards/EventCard";
import ArtistCard from "@/components/wegow/ui/cards/ArtistCard.vue";
import VenueCard from "@/components/wegow/ui/cards/VenueCard.vue";

import { onBeforeMount, ref, watch } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";

const { recommendations, getRecommendations, deleteAd } = useRecommendation();
const { isAuth } = useUser();

const props = defineProps({
  mixed: {
    type: Boolean,
    default: false
  }
});

const isClicking = ref(false);
const showLink = ref(true);

const loaded = ref(false);

const settings = {
  settings: {
    itemsToShow: 1,
    snapAlign: "center"
  }
};
const getClass = section => {
  if (
    section.style_type === 4 ||
    (section.style_type === 1 && section.type !== "event")
  ) {
    return "large-carousel";
  } else if (section.style_type === 5) {
    return "special-carousel";
  } else {
    return "";
  }
};
const breakpoints = section => {
  if (props.mixed) {
    if (
      section.style_type === 5 ||
      ["artist", "venue"].includes(section.type)
    ) {
      return {
        0: {
          itemsToShow: 1,
          snapAlign: "start"
        },
        600: {
          itemsToShow: 1.5,
          snapAlign: "start"
        },
        1050: {
          itemsToShow: 2,
          snapAlign: "start"
        },
        1400: {
          itemsToShow: 2.1,
          snapAlign: "start"
        },
        1650: {
          itemsToShow: 3,
          snapAlign: "start"
        }
      };
    } else {
      return {
        0: {
          itemsToShow: 1,
          snapAlign: "start"
        },
        720: {
          itemsToShow: 1.3,
          snapAlign: "start"
        },
        1000: {
          itemsToShow: 2.1,
          snapAlign: "start"
        },
        1200: {
          itemsToShow: 3.5,
          snapAlign: "start"
        },
        // 1600: {
        //   itemsToShow: 3.5,
        //   snapAlign: "start"
        // },
        1800: {
          itemsToShow: 4,
          snapAlign: "start"
        }
      };
    }
  } else {
    if (
      section.style_type === 5 ||
      ["artist", "venue"].includes(section.type)
    ) {
      return {
        0: {
          itemsToShow: 1,
          snapAlign: "start"
        },
        750: {
          itemsToShow: 2,
          snapAlign: "start"
        },
        1050: {
          itemsToShow: 2.5,
          snapAlign: "start"
        },
        1650: {
          itemsToShow: 3,
          snapAlign: "start"
        }
      };
    } else {
      return {
        0: {
          itemsToShow: 1.5,
          snapAlign: "start"
        },
        650: {
          itemsToShow: 2,
          snapAlign: "start"
        },
        850: {
          itemsToShow: 2.5,
          snapAlign: "start"
        },
        1000: {
          itemsToShow: 3,
          snapAlign: "start"
        },
        1400: {
          itemsToShow: 3.5,
          snapAlign: "start"
        }
      };
    }
  }
};

const handleMouseDown = () => {
  isClicking.value = true;
};
const cancelOpen = () => {
  if (isClicking.value && showLink.value) {
    showLink.value = false;
  }
};
const handleMouseUp = () => {
  if (isClicking.value) {
    setTimeout(() => {
      isClicking.value = false;
      showLink.value = true;
    }, 250);
  }
};

const previousChapterTitle = index => {
  if (index > 0) {
    return recommendations.value[index - 1].chapter;
  } else {
    return null;
  }
};

const getDefaultType = section => {
  if (section.style_type === 3) {
    return "special";
  } else if (section.style_type === 4 || section.style_type === 1) {
    return "medium";
  } else if (section.style_type === 5) {
    return "big";
  }
};

const getEventType = section => {
  if (section.style_type === 3) {
    return "special";
  } else if (section.style_type === 5) {
    return "big";
  } else {
    return "main-small";
  }
};
const isRecommendedSection = section =>
  section.slug === "conciertos-destacados-para-ti";

const sectionLink = section => ({
  name: "EventFilter",
  query: { recommendedConcerts: true, slug: section.slug }
});
const init = () =>
  (async () => {
    loaded.value = false;
    await getRecommendations();
    loaded.value = true;
  })();
onBeforeMount(async () => init());

watch(isAuth, async (newValue, oldValue) => {
  loaded.value = false;
  setTimeout(async () => {
    await getRecommendations();
    loaded.value = true;
  }, 250);
});
</script>
<style scoped lang="scss">
.recommendation-page {
  &.special-section {
    background-image: url("@/assets/images/featured-background.webp");
    background-repeat: no-repeat;
    background-size: cover;
    // background-position: center;
    padding: 27px 0;
    animation: bg-animation 5s infinite alternate;
    @media (min-width: $screen-md) {
      animation: move-bg 7s ease infinite;
    }
  }
  .carousel__track {
    margin: auto !important;
  }
  h2 {
    font-weight: 600;
    font-size: 15px;
    @media (min-width: $screen-md) {
      font-size: 20px;
      line-height: 30px;
    }
  }
  // h3 {
  //   font-weight: 400;
  //   font-size: 20px;
  //   line-height: 30px;
  //   color: $topaz;
  // }
  .slide-section {
    width: 100%;
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 768px) {
      // padding-top: 9px;
      // padding-bottom: 14px;
      max-width: 100%;
    }
  }
}
:not(.special-carousel) .carousel__slide {
  width: 160px !important;
  @media (min-width: $screen-md) {
    width: 211px !important;
  }
}
.special-carousel {
  .carousel__slide {
    width: 271px !important;
    @media (min-width: $screen-md) {
      width: 350px !important;
    }
  }
}
.large-carousel {
  .carousel__slide {
    width: 271px !important;
    @media (min-width: $screen-md) {
      width: 283px !important;
    }
  }
}
.carousel__prev {
  left: -40px !important;
}
.carousel__next {
  right: -40px !important;
}
.slider-gradient {
  background: linear-gradient(
    90deg,
    rgba(46, 255, 236, 0) 75%,
    $backgroundBlack 100%
  );
  width: 20%;
  display: none;
  z-index: 2;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  @media screen and (min-width: $screen-lg) {
    display: inline-block;
  }
}
@keyframes bg-animation {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
@keyframes move-bg {
  0% {
    background-position: 0% 0%;
  }
  25% {
    background-position: 50% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 50% 50%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
